import PeopleItem from '@/components/program/PeopleItem';
import ProgramDetailFields from '@/components/program/ProgramDetailFields';
import RuleItem from '@/components/program/RuleItem';
import { CREATE_TRAVEL_PROGRAM_FORM } from '@/constants/forms';
import IdGeneratorService from '@/services/id-generator.service';
import type { ReactNode } from 'react';
import { useFormContext } from 'react-hook-form';
import { MdPeople } from 'react-icons/md';

type Props = {
	activeIndex: number;
	rules: Rule[];
	groups: Group[];
};

interface Group {
	name: string;
	description: string;
	peopleCount: number;
}

type Rule = {
	icon: ReactNode;
	title: string;
	value: string;
	onClick: () => void;
};

const AddTravelProgramForm = (props: Props) => {
	const { activeIndex, rules, groups } = props;
	const { control } = useFormContext();

	const formName = new IdGeneratorService(CREATE_TRAVEL_PROGRAM_FORM).formId;

	const programDetails = (<ProgramDetailFields formName={formName} control={control} />);
	const customize = (
		<div className="space-y-4 mb-5">
			<div className="">
				<h2 className="text-xl text-gray-800 mb-5">Rules</h2>
				<div className="border-t border-gray-200">
					{rules.map((rule) => (
						<RuleItem
							key={rule.value}
							icon={rule.icon}
							title={rule.title}
							value={rule.value}
							onClick={rule.onClick}
						/>
					))}
				</div>
			</div>
			<div className="">
				<h2 className="text-xl text-gray-800 mb-5">People</h2>
				<div className="border-t border-gray-200">
					{groups.map((group) => (
						<PeopleItem
							key={group.name}
							icon={<MdPeople size={24} />}
							name={group.name}
							count={group.peopleCount}
							groups={groups}
						/>
					))}
				</div>
			</div>
		</div>
	);

	return (
		<>
			{activeIndex === 0 && programDetails}
			{activeIndex === 1 && customize}
		</>
	);
};

export default AddTravelProgramForm;
